import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelExtensionEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelExtensionEntity
